import { MPID, type VenueMapping } from '@/types/enums/venues'

// Mapping of MPID codes to their display labels
export const VenueMappings: Record<MPID, VenueMapping> = {
  [MPID.ALLQ]: { label: 'ALLQ' },
  [MPID.BDDK]: { label: 'Tradeweb Direct' },
  [MPID.BIGP]: { label: 'Brownstone' },
  [MPID.BMBW]: { label: 'MBW' },
  [MPID.BMTF]: { label: 'Bloomberg MTF UK' },
  [MPID.BTBS]: { label: 'Bloomberg Tradebook SG' },
  [MPID.BTFE]: { label: 'Bloomberg MTF EU' },
  [MPID.VCON]: { label: 'VCON' },
  [MPID.CDRG]: { label: 'Citadel Securities' },
  [MPID.CSIN]: { label: 'Citadel Securities Institutional' },
  [MPID.GSCO]: { label: 'Goldman Sachs' },
  [MPID.HEAD]: { label: 'Headlands' },
  [MPID.JPMS]: { label: 'JP Morgan' },
  [MPID.JSCA]: { label: 'Jane Street' },
  [MPID.MADV]: { label: 'Millennium' },
  [MPID.MKAA]: { label: 'MarketAxess' },
  [MPID.MKTX]: { label: 'MarketAxess' },
  [MPID.MMNT]: { label: 'Moment Markets' },
  [MPID.MSCO]: { label: 'Morgan Stanley' },
  [MPID.NICD]: { label: 'ICE NICD' },
  [MPID.NITE]: { label: 'Virtu Financial' },
  [MPID.OYLD]: { label: 'Open Yield' },
  [MPID.PACT]: { label: 'BTG Pactual' },
  [MPID.RBCD]: { label: 'RBC' },
  [MPID.TMCC]: { label: 'ICE TMC' },
  [MPID.TMID]: { label: 'Trumid' },
  [MPID.TWDA]: { label: 'Tradeweb Direct' },
  [MPID.TWDI]: { label: 'Tradeweb Institutional' },
  [MPID.VABD]: { label: 'ICE BondPoint' },
}

/**
 * Get label from MPID or return the raw value if no mapping exists
 * @param mpidOrValue - MPID code or any string value
 * @returns The human-readable label if found, otherwise the original value
 */
export const getVenueLabel = (mpidOrValue: string): string => {
  if (mpidOrValue in VenueMappings) {
    return VenueMappings[mpidOrValue as MPID].label
  }
  // Return raw value if no mapping found
  return mpidOrValue
}
